<app-head></app-head>
<router-outlet></router-outlet>
<div id="ctnLang">
    <span (click)="this.setLangage('fr')">Français</span> - <span (click)="this.setLangage('en')">English</span> 
</div>

